var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"main-content",attrs:{"elevation":"0"}},[_c('v-card-title',{staticClass:"py-0"},[_c('api-header')],1),_c('v-card-text',[_c('api-generate'),_c('api-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }